<div style="
padding-top: 5px;
    text-align: center;
        ">
    <div class="container">
        <div class="block-header__body">

            <h1 class="block-header__title" #titleElement>Contact Us</h1>
        </div>
    </div>

</div>
<div class="block">
    <div class="container container--max--lg">
        <div class="card contacts">
            <div class="contacts__map">

                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.659586714384!2d75.73796691504491!3d26.91429668312699!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db361cb14670f%3A0x1e042127b8456b9f!2sConfirm%20Admission%20-%20LLB%20Admission%20In%20India%20-%20Pharmacy%20Admission%20In%20India!5e0!3m2!1sen!2sin!4v1624687291903!5m2!1sen!2sin" frameborder='0' scrolling='no' marginheight='0' marginwidth='0'></iframe>
            </div>
            <div class="card-body card-body--padding--2">
                <div class="row">
                    <div class="col-12 col-lg-6 pb-4 pb-lg-0" *ngIf="detail">
                        <div class="mr-1">
                            <h4 class="contact-us__header card-title">Our Address</h4>

                            <div class="contact-us__address">
                                    <p>
                                        <strong>
                                            Address:
                                        </strong><br>

                                            {{ detail.address }}
                                            <br><div style="padding-top: 25px;"></div>
                                        <strong>
                                            Email:
                                        </strong> <br>{{ detail.email }}<br><div style="padding-top: 2px;"></div></p>
                                    <p>
                                    <strong>
                                        Primary Secondary Number:
                                    </strong><br>
                                     {{ detail.primary_phone_no}}<br></p><div style="padding-top: 2px;"></div>
                                     <p>
                                     <strong>
                                        Secondary Phone Number:
                                     </strong><br>
                                    {{ detail.secondary_phone_no}}

                                </p>


                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="ml-1">
                            <h4 class="contact-us__header card-title">Leave us a Message</h4>

                            <form #contactForm="ngForm" (ngSubmit)="submit(contactForm)">
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="form-name">Your Name</label>
                                        <input type="text" #name="ngModel"  name="name" [ngModel]="user.name" id="form-name" class="form-control" placeholder="Your Name" required>
                                        <div *ngIf="name.dirty" >
                                            <div *ngIf="name.errors">
                                                <div *ngIf="name.errors.required"  style="color: red;">
                                                    This field required.
                                                </div>

                                             </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="form-phone-number">Phone Number</label>
                                        <input type="text" minlength="10" maxlength="10"
                                        pattern="^[0-9]*$"
                                        #phone_no="ngModel" name="phone_no" [ngModel]="user.phone_no" id="form-phone-number" class="form-control" required placeholder="Your Phone Number">
                                        <div *ngIf="phone_no.dirty" >
                                            <div *ngIf="phone_no.errors">
                                                <div *ngIf="phone_no.errors.required"  style="color: red;">
                                                    This field required.
                                                </div>

                                                <div *ngIf="phone_no.errors.pattern" style="color: red;">
                                                   Only Numbers allowed.
                                                </div>
                                                <div *ngIf="phone_no.errors.minlength"  style="color: red;">
                                                    Invalid Number
                                                  </div>

                                             </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="form-group">
                                    <label for="form-email">Email</label>
                                    <input type="email"
                                    required [pattern]="emailPattern"
                                    #email="ngModel" name="email" [ngModel]="user.email" id="form-email" class="form-control" placeholder="Email Address">
                                    <div *ngIf="email.dirty" >
                                        <div *ngIf="email.errors">
                                            <div *ngIf="email.errors.required"  style="color: red;">
                                                This field required.
                                            </div>
                                            <div *ngIf="email.errors.pattern"  style="color: red;">
                                                Please enter a valid Email.
                                            </div>
                                         </div>
                                    </div>

                                </div>
                                <div class="form-group">
                                    <label for="form-subject">Subject</label>
                                    <input type="text" #subject="ngModel" name="subject" [ngModel]="user.subject" id="form-subject" class="form-control" required placeholder="Subject">
                                    <div *ngIf="subject.dirty" >
                                        <div *ngIf="subject.errors">
                                            <div *ngIf="subject.errors.required"  style="color: red;">
                                                This field required.
                                            </div>

                                         </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="form-message">Message</label>
                                    <textarea id="form-message" #message="ngModel" name="message" [ngModel]="user.message" required class="form-control" rows="4"></textarea>
                                    <div *ngIf="message.dirty" >
                                        <div *ngIf="message.errors">
                                            <div *ngIf="message.errors.required"  style="color: red;">
                                                This field required.
                                            </div>

                                         </div>
                                    </div>
                                </div>
                                <button type="submit" [disabled]="contactForm.invalid" class="btn btn-primary">Send Message</button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-block-space layout="before-footer"></app-block-space>
